import React, { useState, useMemo, useContext, useEffect } from "react";
import MainContext from "../../context/Main/MainContext";
import { AiTwotoneDelete } from "react-icons/ai";

import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Createaccountform.css";
import "react-toastify/dist/ReactToastify.css";

import Terms from "../terms";
import LoadingLogo from "../LoadingLogo/LoadingLogo";

import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { baseUrl } from "../../config/endpoints";
import { baseUrl2 } from "../../config/endpoints";
import AddSignatory from "../Modal/AddSignatory";
import Table from "../Table/Table";
import { MdDelete } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import { ClipLoader } from "react-spinners";

const initialFieldValues = {
  businessName: "",
  phone: "",
  directorBVN: "",
  email: "",
  Tin: "",
  registrationNumber: "",
  address: "",
  branch: "",
};
const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validationSchema = Yup.object().shape({
  address: Yup.string().required("Address is required"),
  directorBVN: Yup.string()
    .required("Director's BVN is required")
    .length(11, "Director's BVN should be 11 characters long"),
  businessName: Yup.string()
    .required("Business Name is required")
    .min(5, "Business Name should be at least 5 characters long"),
  email: Yup.string()
    .matches(emailValidationRegex, "Invalid email address")
    .required("Email is required"),

  registrationNumber: Yup.string().length(
    9,
    "RC number should be 9 characters long",
  ),
  phone: Yup.string()
    .required("Phone number is required")
    .min(11, "Phone number should be at least 11 digits")
    .max(16, "Phone number should not exceed 16 digits"),
  branch: Yup.string().required("Branch is required"),
  Tin: Yup.string()
    .required("Tin is required")
    .min(10, "Tin should be at least 10 digits")
    .max(14, "Tin should not exceed 14 digits"),
});

const fileOptionsByAccount = [
  {
    id: 2,
    fileName: "certificate-of-Incorporation",
    display: "Certificate of Incorporation",
  },
  {
    id: 3,
    fileName: "evidence-of-tin",
    display: "Evidence of TIN/TAX",
  },
  {
    id: 4,
    fileName: "memorandum-and-articles",
    display: "Memorandum and Articles",
  },
  {
    id: 5,
    fileName: "form-co2-and-co7",
    display: "Form CO2 and CO7",
  },
  {
    id: 6,
    fileName: "utility-bill-and-address-verified",
    display: "Utility Bill / Address Verification",
  },

  {
    id: 7,
    fileName: "application-form-for-registeration-of-business-name",
    display: "Application Form for Registeration of Business Name",
  },

  {
    id: 8,
    fileName: "board-resolution-under-seal",
    display: "Board Resolution Under Seal",
  },
  {
    id: 9,
    fileName: "partnership-deed",
    display: "Partnership Deed",
  },

  {
    id: 10,
    fileName: "reference",
    display: "Reference",
  },
];

function Createaccountform() {
  const navigate = useNavigate();

  const [documents, setDocuments] = useState([]);

  const [failed, setFailed] = useState(false);

  const [agreementCheckBox, setAgreementCheckBox] = useState(false);
  const [showTerm, setShowTerm] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [bvnDetails, setBvnDetails] = useState(null);
  const [open, setOpen] = useState(false);
  const [allbranches, setAllBranches] = useState([]);

  const {
    signatories,
    setSignatories,
    setSignatoriesDocuments,
    signatoriesDocuments,
    merchantDetails,
  } = useContext(MainContext);
  const merchantDetailsArray = merchantDetails
    ? JSON.parse(merchantDetails)
    : [];
  const API_URL = process.env.REACT_APP_Api_URL_branch;
  const columns = useMemo(
    () => [
      {
        Header: "BVN",
        accessor: "directorBVN",
      },
      {
        Header: "Phone Number",
        accessor: "phone",
      },

      {
        Header: "Occupation",
        accessor: "occupation",
      },
      {
        Header: "Religion",
        accessor: "religion",
      },
      {
        Header: "Mother Maiden Name",
        accessor: "motherMaidenName",
      },
      {
        Header: "state Of Origin",
        accessor: "stateOfOrigin",
      },
      {
        Header: "Action",
        Cell: ({ cell, row }) => {
          const data = cell.row.original;
          const { id } = row.original; // Get the id from row.original
          const { index } = row; //

          const show = (
            <div
              // type="button"
              className=" text-center w-[100%] justify-center items-center  text-white p-[6px] rounded-md text-xs hover:opacity-75"
              onClick={() => {
                handleDeleteItem(index);
              }}
            >
              <MdDelete size="20px" color="#FDB815" />
            </div>
          );

          return show;
        },
      },
    ],
    [],
  );

  const {
    values,
    errors: formikErrors,
    setFieldValue,
    touched,
    handleSubmit: formikHandleSubmit,
    handleChange,
    isSubmitting,
  } = useFormik({
    initialValues: initialFieldValues,
    validationSchema: validationSchema,
    onSubmit: async (value) => {
      const payload = {
        ...signatories,
        ...merchantDetailsArray,
        companyDetails: value,
      };
      const isBvnInSignatories = signatories?.some((item) => {
        return item.directorBVN === values.directorBVN;
      });

      if (signatories.length === 0) {
        toast.error("Signatories cannot be empty");
        return;
      }
      if (!isBvnInSignatories) {
        toast.error(
          "Director's BVN does not match any individual's BVN added as signatory",
        );
        return;
      }

      if (bvnDetails?.ResponseCode === "01") {
        Swal.fire({
          title: "Bvn Invalid",
          text: "Please provide a valid bvn to continue",
          icon: "error",
        });
        return;
      }
      if (documents.length < 9) {
        toast.error("Company documents must be complete");
        return;
      }
      try {
        const formData = new FormData();
        signatoriesDocuments.forEach((obj, index) => {
          Object.keys(obj).forEach(([key, value]) => {
            const fileName = `${obj[key]?.fileName}-${index}`;

            formData.append("signatories-file", obj[key].file?.[0], fileName);
          });
        });

        for (let i = 0; i < documents.length; i++) {
          formData.append(documents[i]?.fileName, documents[i].file?.[0]);
        }

        formData.append("data", JSON.stringify(payload));
      
        const response = await axios.post(
          baseUrl + "/hangouts/smelab/business/preregistration",
          formData,
          {
            headers: {
              // "Content-Type" : "application/json"
            },
          },
        );

        if (response.status === 200) {
          // sessionStorage.setItem("userCode" , response.data.userCode)
          // sessionStorage.setItem("uniqueID" , response.data.uniqueID)
          // setSubmitting(true);
          navigate(
            `/token/${response.data.userCode}/${response.data.uniqueID}`,
          );
          // setEmail("");
        }
      } catch (error) {
        if (error.message === "Network Error") {
          setFailed(true);
        }

        if (error.response) {
          toast.error(error.response.message);
        }
      }
    },
  });

  const getAllBranch = async () => {
    try {
      const response = await axios.get(
        API_URL + "branches",
        // "https://providusonline.providusbank.com:8443/apitest/branches"
      );

      setAllBranches(response?.data?.branches);
    } catch (er) {}
  };
  useEffect(() => {
    // Save state to sessionStorage whenever it changes
    getAllBranch();
    sessionStorage.setItem(
      "signatoriesDocuments",
      JSON.stringify(signatoriesDocuments),
    );

    sessionStorage.setItem("signatories", JSON.stringify(signatories));
  }, [signatories]);

  const handleClose = () => {
    setShowTerm(false);
  };

  const availableOptions = useMemo(() => {
    const documentsSelected = documents.reduce((a, b) => {
      a.push(b?.fileName);
      return a;
    }, []);
    return fileOptionsByAccount.filter(
      (option) => !documentsSelected.includes(option?.fileName),
    );
  }, [documents]);

  const [currentOption, setCurrentOption] = useState(null);

  const handleOptionChange = (e) => {
    setCurrentOption(e?.target?.value);
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    const selectedFile = e?.target?.files;
    if (!selectedFile) {
      return;
    }

    const isDocumentAlreadyUploaded = documents.find(
      (doc) => doc.id === currentOption?.id,
    );

    if (isDocumentAlreadyUploaded) {
      return;
    }

    const parsedOption = JSON.parse(currentOption);
    const currentFileObject = { ...parsedOption, file: selectedFile };

    setDocuments((documents) => {
      const newDocument = [...documents, currentFileObject];
      return newDocument;
    });
    setCurrentOption(null);
  };
  sessionStorage.setItem("email", values?.email);

  const handleDelete = (id) => {
    setDocuments((documents) => documents.filter((doc) => doc?.id !== id));
  };

  const handleNumericInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");

    const { name } = e.target;
    setFieldValue(name, value);
    if (name === "directorBVN") {
      setBvnDetails(null);
    }
  };

  const handleDeleteItem = (id) => {
    // delete the from the signatories
    const updatedItems = signatories.filter((item, index) => {
      return index !== id;
    });
    //  Delete from the signatories Document
    const updatedItemsDocument = signatoriesDocuments.filter((item, index) => {
      return index !== id;
    });

    setSignatories(updatedItems);
    setSignatoriesDocuments(updatedItemsDocument);
  };
  const validateBvn = async (bvn) => {
    const payload = {
      BVN: bvn,
    };

    setIsLoading(true);
    setBvnDetails(null);
    try {
      const response = await axios.post(
        baseUrl2 + "/account/ops/validate_bvn",
        payload,
      );

      setBvnDetails(response.data);
      const reference = `${bvn}${Date.now()}`;
      sessionStorage.setItem("reference", reference);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  const handleBvnBlur = async (e) => {
    // console.log(e.target.value);
    if (values?.directorBVN?.length === 11) {
      await validateBvn(values?.directorBVN);
    }
  };

  return (
    <>
      <form
        className="createaccount_form"
        // onSubmit={handleSubmit(onSubmit)}
        onSubmit={formikHandleSubmit}
      >
        <div className="createaccount_header">
          <h2>
            <span>PROVIDUSBANK CORPORATE</span> ACCOUNT OPENING
          </h2>
          <p>fill in all the information below as accurately as possible</p>
        </div>
        <div className="input-group">
          <div className="input-container">
            <label>Company Name</label>

            <input
              className="input"
              type="text"
              name="businessName"
              id="businessName"
              value={values?.businessName}
              placeholder="Business Name"
              onChange={handleChange}
              // error={errors.name}
            />
            {touched?.businessName && formikErrors?.businessName ? (
              <p className="error">{formikErrors?.businessName}</p>
            ) : null}
          </div>

          <div className="input-container">
            <label>Email</label>
            <input
              type="email"
              name="email"
              id="email"
              className="input"
              placeholder="example@example.com"
              required={false}
              value={values?.email}
              onChange={handleChange}
            />
            {touched?.email && formikErrors?.email ? (
              <p className="error">{formikErrors?.email}</p>
            ) : null}
          </div>
          <div className="input-container">
            <label>Phone Number</label>
            <input
              className="input"
              name="phone"
              id="phone"
              value={values?.phone}
              onChange={handleNumericInputChange}
              placeholder="1234567890"
            />
            {touched?.phone && formikErrors?.phone ? (
              <p className="error">{formikErrors?.phone}</p>
            ) : null}
          </div>
          <div className="input-container">
            <label>Registration Number</label>
            <input
              className="input"
              type="string"
              name="registrationNumber"
              id="registrationNumber"
              value={values?.registrationNumber}
              onChange={handleChange}
              placeholder="RC12345"
              // onBlur={handleRcBlur}
            />

            {touched?.registrationNumber && formikErrors?.registrationNumber ? (
              <p className="error">{formikErrors.registrationNumber}</p>
            ) : null}
          </div>

          <div className="input-container">
            <label>Tax Identification Number</label>
            <input
              className="input"
              name="Tin"
              id="Tin"
              value={values?.Tin}
              onChange={handleNumericInputChange}
              placeholder="12345678"
            />
            {touched?.Tin && formikErrors?.Tin ? (
              <p className="error">{formikErrors.Tin}</p>
            ) : null}
          </div>
          <div className="input-container">
            <div className="input-container-signatory">
              <label> Director's BVN</label>
              <input
                className="input"
                name="directorBVN"
                value={values?.directorBVN}
                onChange={handleNumericInputChange}
                placeholder="22222222222"
                onBlur={handleBvnBlur}
              />
              {isLoading ? (
                <div>
                  <ClipLoader color="#FFB200" size={18} /> ...validating{" "}
                </div>
              ) : (
                ""
              )}
              {bvnDetails ? (
                <div>
                  {" "}
                  {bvnDetails?.ResponseCode === "00" ? (
                    <p className="success_text">
                      {bvnDetails.vFirstName +
                        " " +
                        bvnDetails.vMiddleName +
                        " " +
                        bvnDetails.vLastName}
                    </p>
                  ) : bvnDetails?.ResponseCode !== "00" ? (
                    <p className="error_text">Invalid bvn</p>
                  ) : (
                    ""
                  )}
                </div>
              ) : null}
              {touched?.directorBVN && formikErrors?.directorBVN ? (
                <p className="error">{formikErrors?.directorBVN}</p>
              ) : null}
            </div>
          </div>
          <div className="input-container">
            <div className="input-container-signatory">
              <label>Branch</label>
              <select
                className="input"
                name="branch"
                value={values?.branch}
                onChange={handleChange}
              >
                <option value="">--Select Branch</option>
                {allbranches?.map((row, index) => {
                  return (
                    <option value={row?.code} key={index}>
                      {row?.name}
                    </option>
                  );
                })}
              </select>
              {touched?.branch && formikErrors?.branch ? (
                <p className="error">{formikErrors?.branch}</p>
              ) : null}
            </div>
          </div>
        </div>

        <div className="input-group">
          <div className="input-container"></div>
        </div>

        <div className="input-address-container">
          <label>Address</label>
          <textarea
            rows="3"
            className="address_input"
            type="text"
            name="address"
            id="address"
            value={values?.address}
            onChange={handleChange}
          />
          {touched?.address ? (
            <p className="error">{formikErrors?.address}</p>
          ) : null}
        </div>
        {/* <div className="input-address-container">
          <label>Current Address</label>
          <textarea
            rows="3"
            className="address_input"
            type="text"
            name="currentAddress"
            id="currentAddress"
            value={values?.currentAddress}
            onChange={handleChange}
          />
          {touched?.currentAddress ? (
            <p className="error">{formikErrors?.currentAddress}</p>
          ) : null}
        </div> */}
        <div>
          <div className="file-list-container">
            {documents?.map((doc) => (
              <div key={doc?.id} className="document_item">
                <div className="file-name">
                  <strong>{doc?.display}</strong>
                  <span>{doc?.file?.[0]?.name}</span>
                </div>
                <button onClick={() => handleDelete(doc?.id)}>
                  <AiTwotoneDelete className="button-icon" />
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="file_upload">
          <div>
            <select onChange={handleOptionChange} className="file_select">
              <option value=""> Select document to upload</option>
              {availableOptions?.map((availableOption) => {
                return (
                  <option
                    key={availableOption?.id}
                    value={JSON.stringify(availableOption)}
                  >
                    {availableOption?.display}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="upload">
            <label htmlFor="available-option">Upload</label>
          </div>
          <input
            type="file"
            id="available-option"
            onChange={handleFileUpload}
            disabled={!currentOption}
            accept=".pdf, .jpg, .jpeg, .png, .doc, .xlsx, .xlsm, .xlsb"
          />
        </div>
        <button
          type="button"
          className="button_createacc"
          onClick={() => {
            setOpen(true);
          }}
        >
          + Add Signatory
        </button>
        <Table data={signatories} columns={columns} />

        <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <input
            style={{ marginRight: "15px" }}
            type="checkbox"
            required={true}
            checked={agreementCheckBox}
            onChange={() => setAgreementCheckBox(!agreementCheckBox)}
          />
          I Agree to the
          <p
            onClick={() => setShowTerm(true)}
            style={{
              color: "#efb331",
              cursor: "pointer",
              marginTop: "15px",
            }}
          >
            {" "}
            Terms & Conditions
          </p>
        </div>

        <div className="createaccount_buttoncontainer">
          {!isSubmitting ? (
            <button type="submit" className="button_createacc">
              {" "}
              Submit
            </button>
          ) : (
            <button type="submit" className="button_createacc">
              <PulseLoader color="#fff" size={10} />
            </button>
          )}
          {!failed ? (
            <span className="error">{""}</span>
          ) : (
            <span className="error">*no network</span>
          )}

          <a
            href="https://providusbank.com/wp-content/uploads/2021/09/ProvidusBank-Privacy-Notice-policy.pdf"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none" }}
          >
            Privacy Policy
          </a>
        </div>
      </form>
      <AddSignatory state={open} setState={setOpen} />
      <Terms showTerm={showTerm} handleClose={handleClose} />
      <ToastContainer position="top-right" />
      {isSubmitting || isLoading ? <LoadingLogo /> : null}
    </>
  );
}

export default Createaccountform;
